//
// Unified Event Handling
//
module.exports = (function() {
    var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
    var _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
    var ticking = {};
    var elementRenderTries = 0;

    var cancel = function EventCancelFunc(event) {

        if ( typeof event !== 'undefined' && event && event.preventDefault ) {
            event.preventDefault();
        }
    };

    var stopPropagation = function StopPropagationFunc(event) {

        if ( typeof event !== 'undefined' && event && event.stopPropagation ) {
            event.stopPropagation();
        }
    }

    // callback on requested frame,
    // then set to "not ticking" to start over
    var doTick = function(identifier, callback) {
        callback();
        ticking[identifier] = false;
    };

    // check if ticking,
    // if not, request the next frame
    var tick = function(identifier, callback) {

        if ( ! ticking[identifier] ) {
            window.requestAnimationFrame(doTick.bind(this, identifier, callback));
            ticking[identifier] = true;
        }
    };

    //
    // Fastest possible event triggers
    // Only use on VERY lightweight functions!
    //
    var cling = function EventClingFunc(identifier, callback) {
        ticking[identifier] = false;

        return tick.bind(this, identifier, callback);
    };

    //
    // Wait for an element to hit the DOM, or give up
    //
    var onElementRendered = function ElementLoadedFunc(element, callback) {
        var $element = $(element);

        // give up if it never renders
        if ( elementRenderTries < 1000 && $element.width === 0 ) {
            elementRenderTries++;

            window.requestAnimationFrame(onElementRendered.bind(this, element, callback));
        } else {
            elementRenderTries = 0;
            callback(element);
        }
    };

    return {
        cancel: cancel,
        cling: cling,
        stopPropagation: stopPropagation,
        onElementRendered: onElementRendered
    };
})();
